import { Button } from '@bphxd/ds-core-react';
import { FC } from 'react';

const SaveCancelButtons: FC<{
  onSave: () => void;
  onCancel: () => void;
  saveDisabled: boolean;
  saveLabel?: string;
  cancelLabel?: string;
}> = ({ onSave, onCancel, saveDisabled, saveLabel = 'Save changes', cancelLabel = 'Cancel' }) => (
  <div className="d-flex gap-4 flex-row-reverse">
    <Button size="lg" theme="darker" level="primary" disabled={saveDisabled} onClick={onSave}>
      {saveLabel}
    </Button>
    <Button size="lg" theme="darker" level="tertiary" onClick={onCancel}>
      {cancelLabel}
    </Button>
  </div>
);

export default SaveCancelButtons;
